module.exports = __webpack_public_path__ + "img/MH.42acb2fc.png";